import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { areColumnsEqual } from "../../utils/sortUtils";

interface SortIconProps {
  column: string;
  sortBy?: string;
  sortDirection?: "ASC" | "DESC";
}

export function SortIcon({ column, sortBy, sortDirection }: SortIconProps) {
  const isActive = areColumnsEqual(sortBy, column);

  if (!isActive) {
    return <ArrowUpDown className="h-3 w-3 ml-1 opacity-50" />;
  }

  return sortDirection === "ASC" ? (
    <ArrowUp className="h-3 w-3 ml-1" />
  ) : (
    <ArrowDown className="h-3 w-3 ml-1" />
  );
}
